module.exports = __webpack_public_path__ + "images/browser-ui.jpg";